import ReactDOM from 'react-dom/client';
import './styles/index.css';
import './styles/globals.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import ContextProvider from './store/ContextProvider';
import ExploreContextProvider from './store/ExploreData';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <BrowserRouter>
        <ContextProvider>
            <ExploreContextProvider>
                <App />
            </ExploreContextProvider>
        </ContextProvider>
    </BrowserRouter>
);

